import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Response_Processing from "../../../layout/Others/Response_Processing";
import AdminSliderModal from "../../../components/CommonComponents/AdminSliderModal";
import AdminDeleteModal from "../../../components/CommonComponents/AdminDeleteModal";
import AdminNavbar from "../../../components/CommonComponents/AdminNavbar";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import { toast } from "react-toastify";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import { FaEllipsisVertical } from "react-icons/fa6";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { Link } from "react-router-dom";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import { RxReload } from "react-icons/rx";
import ExportIcon from "../../../components/Images/icons/Export_Icon_01.png";
import { IoClose } from 'react-icons/io5';
import { MdKeyboardDoubleArrowLeft, MdOutlineKeyboardDoubleArrowRight } from 'react-icons/md';
import { donwloadCSV, downloadPDF, downloadXLSX } from "../../../components/CommonMethod/CommonMethods";
import { IconDeleteFigma, IconEditFigma } from "../../../Assets/MyIcons";
import AdminTooltip from "../../../components/CommonComponents/AdminTooltip";


function SidebarMenu() {
    const baseURL = process.env.REACT_APP_Baseurl
    const indexApi = `${baseURL}/admin/sidebar_menu/index`
    const deleteApi = `${baseURL}/admin/sidebar_menu/multi-delete`
    const suffleApi = `${baseURL}/admin/sidebar_menu/ordering`
    const activateApi = `${baseURL}/admin/active-sidebar_menu`

    const { fetchRequest, deleteImageFile } = useMyContext()
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [apiData, setApiData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [showOverlay, setShowOverlay] = useState(false);
    const [loading, setLoading] = useState(true)
    const [modalClose, setModelClose] = useState(false)
    const [selectAllData, setSelectAllData] = useState(false);
    const [itemDelete, setItemDelete] = useState([])
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [filter, setFilter] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);


    const fetchData = async (type) => {
        setShowOverlay(true);
        setLoading(true);

        try {
            const response = await fetchRequest({
                method: 'GET',
                url: `${indexApi}`,
                params: {},
                data: {},
            });

            if (response?.status) {
                const updatedList = response?.menus;
                setApiData(updatedList);
                setFilteredData(updatedList);
                if (type === "CSV") {
                    await donwloadCSV(updatedList, "SIDEBAR-MENU-LIST");
                }
                if (type === "PDF") {
                    await downloadPDF(updatedList, "SIDEBAR-MENU-LIST", ["S.NO", "ID", "NAME"]);
                }
                if (type === "XLSX") {
                    await downloadXLSX(updatedList, "SIDEBAR-MENU-LIST", ["S.NO", "ID", "NAME"]);
                }
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setShowOverlay(false);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [withOutRefresh]);

    const handleDeleteImage = async () => {
        await deleteImageFile(itemDelete, "SidebarMenu");
    }

    const handleDelete = async () => {
        setShowOverlay(true);
        handleCloseModal()
        await handleDeleteImage();
        try {
            const response = await fetchRequest({
                method: 'DELETE',
                url: `${deleteApi}`,
                params: {},
                data: { id: [...itemDelete] },
            })

            const result = response;
            if (result?.status) {
                toast.success(result?.message)
                setWithOutRefresh(!withOutRefresh)
                setSelectAllData(false)
            }
        }
        catch (err) {
            const errMessage = err?.response?.data?.message
            toast.error(errMessage)
        }
        finally {
            setLoading(false)
            setShowOverlay(false);
        }
    }

    const saveShuffleOrder = async (updatedItems) => {
        setShowOverlay(true);

        if (!updatedItems || updatedItems?.length === 0) {
            toast.error("Menu items are empty");
            return;
        }
        else {
            const ids = updatedItems?.map((menuItem) => menuItem?.id);
            const positions = updatedItems?.map((_, index) => index + 1);
            const requestData = {
                id: ids,
                position: positions,
            };
            try {
                const response = await fetchRequest({
                    method: 'PATCH',
                    url: `${suffleApi}`,
                    params: {},
                    data: requestData,
                })
                const result = response;
                if (result?.status) {
                    toast.success(result?.message)
                    setWithOutRefresh(!withOutRefresh)
                    setShowOverlay(false);
                }
                else {
                    setShowOverlay(false)
                    toast.error(result?.message)
                }
            } catch (err) {
                setShowOverlay(false)
                console.error(err);
                var errorMessage = err?.response?.data?.message;
                toast.error(errorMessage)
            }
        }
    };

    const handleDragEnd = (result) => {
        if (!result.destination) return;
        const reorderedItems = Array.from(apiData);
        const [movedItem] = reorderedItems?.splice(result.source.index, 1);
        reorderedItems?.splice(result.destination.index, 0, movedItem);
        setApiData(reorderedItems);
        setFilteredData(reorderedItems);
        saveShuffleOrder(reorderedItems);
    };

    const handleSelectAllData = () => {
        setSelectAllData(!selectAllData);
        setItemDelete(selectAllData ? [] : apiData?.map((item) => item?.id));
    };

    const handleSingleFile = (itemId) => {
        if (itemDelete?.includes(itemId)) {
            setItemDelete(
                itemDelete?.filter((id) => id !== itemId)
            );
        } else {
            setItemDelete([...itemDelete, itemId]);
        }
    };

    const handleCloseModal = () => {
        setModelClose(!modalClose)
        setItemDelete([]);
    }

    const handleOpenDeleteModal = async () => {
        setModelClose(true)
    }

    const confirmToggle = async () => {
        setShowOverlay(true);
        setShowModal(false);
        try {
            const newStatus = currentItem?.active === 1 ? 0 : 1;

            const formData = {
                menu_id: currentItem?.id,
                active: newStatus,
            };

            const response = await fetchRequest({
                method: 'POST',
                url: `${activateApi}`,
                params: {},
                data: formData,
            })
            const result = response
            if (result.status) {
                setWithOutRefresh(!withOutRefresh);
                toast.success(result?.message);
                setShowOverlay(false);
                setCurrentItem(null);
            }
            else {
                toast.error(result?.message);
                setShowOverlay(false);
            }
        } catch (err) {
            var errorMessage = err?.response?.data?.message;
            toast.error(errorMessage);
            setShowOverlay(false);
        }
    };

    const handleToggle = async (e, item) => {
        setCurrentItem(item);
        setShowModal(true);
    };

    const closeModal = () => {
        setModelClose(!closeModal);
        setShowModal(false);
        setItemDelete([]);
    };

    const singleDelete = (id) => {
        setModelClose(true);
        setItemDelete([id]);
    };
    const reloadAction = () => {
        setWithOutRefresh(prev => !prev)
    }

    const handleFilter = (event) => {
        const searchTerm = event.target.value.toLowerCase().trim();
        setFilter(searchTerm);
        if (searchTerm === '') {
            setFilteredData(apiData);
            return;
        }

        const filteredResults = apiData?.filter((item) =>
            ["id", "name", "role", "title", "column_position"].some((property) => {
                const value = item[property];
                if (typeof value === "string" && value) {
                    return value.toLowerCase().includes(searchTerm);
                }
                if (typeof value === "number" && property === "id") {
                    return value.toString().includes(searchTerm);
                }
                return false;
            })
        );

        setFilteredData(filteredResults);
    };

    const handleClear = () => {
        setFilter('');
        setFilteredData(apiData); // Reset to full list
    };
    return (
        <>
            {showOverlay && <Response_Processing />}
            {modalClose && <AdminDeleteModal modelClose={modalClose} deleteClose={closeModal} deleteAction={handleDelete} buttonText={itemDelete?.length} />}
            {showModal ? <AdminSliderModal modalDescription={`Do you want to  ${currentItem?.active == 1 ? 'disable' : 'enable'} this sidebar menu ?`} modalHeading={"Menu Status"} modelClose={showModal} sliderClose={closeModal} sliderAction={confirmToggle} buttonText={currentItem?.active} /> : ""}
            <AdminNavbar heading={'All Sidebar Menu'} totalDataLength={filteredData?.length} deleteCount={itemDelete?.length} navigation={'/addsidebarmenu'} deleteMethod={handleOpenDeleteModal} navText={'Add Sidebar Menu'} />
            <div className="bootstrapTable theme-bg-color p-3 rounded-2">
                <div className='d-flex align-items-center flex-wrap justify-content-between mb-3'>
                    <div className="filterContainer">
                        <input type='text' placeholder="Search" className="filter form-control theme-text-color theme-bg-color theme-border-secondary" value={filter} onChange={(event) => handleFilter(event)} />
                        {filter?.length > 0 && (<button type="button" className="clearBtn" onClick={() => handleClear()}  ><IoClose className="custom-close-btn" /> </button>)}
                    </div>
                    <div className='d-flex align-items-center'>
                        <button id="reloadButton" className={`custom-tool-tip-parent bg-transparent reloadButton theme-text-color p-2 me-2  border border-2 rounded-circle theme-border-color `} onClick={reloadAction}>
                            <RxReload style={{ width: "18px", height: "15px" }} className={`${loading ? "rotate-load" : ""}`} />
                            <AdminTooltip text="Refresh" top={"-41px"} className="d-none custom-tool-tip" />

                        </button>
                        <div className="dropdown d-block ms-2 " key={"2"}>
                            <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportAllButton" data-bs-toggle="dropdown" aria-expanded="false"  >
                                <span className="fw-bolder text-white">Export All</span>
                                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
                            </button>
                            <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportAllButton" >
                                <li id="exportallCSV" className="dropdown-item theme-text-color cursor-pointer" onClick={() => fetchData("CSV", "ALL")}>CSV</li>
                                <li id="exportallPDF" className="dropdown-item theme-text-color cursor-pointer" onClick={() => fetchData("PDF", "ALL")}>PDF</li>
                                <li id="exportallXLSX" className="dropdown-item theme-text-color cursor-pointer" onClick={() => fetchData("XLSX", "ALL")}>XLSX </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="">
                    <div className="d-flex flex-wrap theme-border-bottom-secondary pb-3">
                        <div className="rowCheckboxDrag d-flex justify-content-end col-1 p-2"> <label><input type="checkbox" checked={selectAllData} onChange={handleSelectAllData} /> </label></div>
                        <div className="col-4 p-2 "> <label className="theme-text-color fw-bold d-flex justify-content-center fs-6"> Sidebar Menu</label> </div>
                        <div className="col-4 p-2"><label className="theme-text-color fw-bold fs-6">Status</label></div>
                        <div className="col-3 p-2">
                            <label className="theme-text-color fw-bold fs-6">Actions</label>
                        </div>
                    </div>
                    <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable droppableId="menu-items" className="theme-bg-color"   >
                            {(provided) => (
                                <ul  {...provided.droppableProps} ref={provided.innerRef} className="pb-5 px-0 theme-bg-color m-0 p-0 list-unstyled">
                                    {loading ? <NoRecordTable result={filteredData?.length} loader={true} /> :
                                        filteredData.length ? filteredData?.map((item, index) => (
                                            <Draggable key={item?.id.toString()} draggableId={item?.id.toString()} index={index} >
                                                {(provided) => (
                                                    <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className={` theme-bg-color theme-text-color   ${item.order} index ${index + 1} w-100 theme-border-bottom-secondary px-3`} >
                                                        <div className="d-flex  align-items-center">

                                                            <div className="rowCheckboxDrag col-1 justify-content-start category-order-title">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={itemDelete?.includes(item.id)}
                                                                    onChange={() => handleSingleFile(item.id)}
                                                                />
                                                            </div>

                                                            <div className="col-4  category-order-title">
                                                                <div className="d-flex justify-content-between align-items-center ">
                                                                    <div className="d-flex gap-2">
                                                                        <img src={item?.image} className="profile" alt="light" />
                                                                        <img src={item?.dark_mode_image} className="profile" alt="dark" />
                                                                    </div>
                                                                    <div className="rightVideoTitle d-flex flex-column px-3">
                                                                        <MessageBox text={`${item?.name}`} classname="admin-input-title" loadingHide />
                                                                        <span className="dateText table-subheading "> {item?.upload_on}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-4 category-order-title">
                                                                <AdminSwitch name="active" checked={item?.active == 1} onChange={(e) => handleToggle(e, item)} id={item?.id} />
                                                            </div>
                                                            <div className="col-3 category-order-title">
                                                                <div className="editdropdown">
                                                                    <span className="editdropdown-button">
                                                                        <FaEllipsisVertical className="theme-text-color" />
                                                                    </span>
                                                                    <div className="editdropdown-menu theme-bg-color">
                                                                        <Link to={`/editsidebarmenu/${item?.id}`} className="theme-text-color theme-bg-color">
                                                                            <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                                                                            <MessageBox text="Edit" classname='ms-2 theme-text-color' />
                                                                        </Link>
                                                                        <div onClick={() => singleDelete(item?.id)} className="commonActionPadding theme-bg-color">
                                                                            <IconDeleteFigma styled={{ width: "20px", height: "20px" }} />
                                                                            <MessageBox text="Delete" classname='ms-2 theme-text-color' />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )}
                                            </Draggable>
                                        )) : <NoRecordTable result={filteredData?.length} loader={false} />}
                                    {provided.placeholder}
                                </ul>
                            )}
                        </Droppable>
                    </DragDropContext>
                </div>
            </div >
        </>
    );
}
export default SidebarMenu;